/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createCustomTheme} from '@ion/dls/src/theme/theme';
import json from './theme.json5';

/**
 * Generates the BMW custom theme which extends the default iOn DLS theme.
 *
 * @see https://www.figma.com/file/pB9u7ccisQ7aQHWhHhYStr/BMW_Portal?node-id=1%3A2
 */
export default createCustomTheme(json);
